module.exports = __webpack_public_path__ + "img/TH.87e953c9.svg";